import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateTeamMeetingConfigsQuery } from './useTeamMeetingConfigsQuery';

export interface ITeamMeetingConfigCreateMutationOptions {
	onSuccess?: (data: Api.ITeamMeetingConfig) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

export function useTeamMeetingConfigCreateMutation(options: ITeamMeetingConfigCreateMutationOptions = {}) {
	const { onSuccess, onError } = options;
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: Api.ITeamMeetingConfigCreateRequest) => {
			return userSession.webServiceHelper.callAsync<Api.ITeamMeetingConfig>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'TeamMeetingConfig',
				}),
				'POST',
				request
			);
		},
		onSuccess: data => {
			invalidateTeamMeetingConfigsQuery();
			onSuccess?.(data);
		},
		onError,
	});
}
